<h5 class="card-title">Critical Teams</h5>
<div *ngFor="let team of teams" class="mb-3">
  <div class="d-flex justify-content-between mb-1">
    <span>{{team?.name}}</span>
    <span>{{team?.value}}%</span>
  </div>
  <div class="progress" style="height: 8px;">
    <div class="progress-bar"
         [style.width.%]="team?.value"
         [style.backgroundColor]="team?.color">
    </div>
  </div>
</div>
